module.exports = __webpack_public_path__ + "img/Icone_192.e9bf042a.png";